import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

const skeletonText = css`
    & + & {
        margin-top: ${size(0.5)};
    }
`;

const skeletonCircle = css`
    border-radius: 50%;
`;

interface ISkeleton {
  $variant?: 'text' | 'circle';
  $width?: number | string;
  $height?: number | string;
  $ratio?: number;
  $inlineBlock?: boolean;
}

export const Skeleton = styled.div.withConfig({ componentId: 'sc-cjrwr8-0' })<ISkeleton>`
    max-width: 100%;
    background-color: var(--c-skeleton);
    border-radius: ${(props) => props.theme.size.borderRadius};

    ${({ $width, $height }) =>
      css`
            height: ${$height || '1.5em'};
            width: ${$width || '100%'};
        `}

    ${({ $ratio }) =>
      $ratio &&
      css`
            width: 100%;
            height: 0;
            padding-bottom: ${$ratio * 100}%;
        `}

  ${({ $variant }) =>
    $variant &&
    css`
            ${$variant === 'text' && skeletonText};
            ${$variant === 'circle' && skeletonCircle};
        `}

${({ $inlineBlock }) =>
  $inlineBlock &&
  css`
            display: inline-block;
            vertical-align: middle;
        `}
`;
